var _defs, _style, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEscudosBajo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74 52",
    width: 74,
    height: 52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "escudos_bajo-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(35.44,0,0,38.46,18.53,27.25)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8c79f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b8b8ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(26.94,-26.94,26.921,26.921,22.77,35.13)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff5e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b51313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g3",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-0.98,-34.59,31.688,-0.898,37.11,45.25)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#e61919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b51313"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: url(#g1) } \r\n\t\t.s1 { fill: url(#g2) } \r\n\t\t.s2 { fill: #ffffff } \r\n\t\t.s3 { opacity: .8;fill: url(#g3) } \r\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m36.2 46.5c-0.8 0-1.6-0.3-2.3-0.8-5-3.8-8.9-8.4-11.5-13.8-2.6-5.3-3.9-11.4-3.9-17.9 0-1.1 0.5-2.2 1.4-2.9 0.7-0.6 1.6-0.9 2.4-0.9 0.3 0 0.6 0.1 1 0.2 0.8 0.1 2.1 0.3 3.6 0.3q4.1 0 7.3-2.1c0.6-0.4 1.3-0.6 2-0.6 0.8 0 1.5 0.2 2.1 0.6 2.1 1.4 4.6 2.1 7.3 2.1 1.4 0 2.7-0.2 3.5-0.3 0.5-0.1 0.8-0.2 1.1-0.2 0.8 0 1.7 0.3 2.4 0.9 0.9 0.7 1.4 1.8 1.4 2.9 0 6.4-1.3 12.4-3.8 17.7-2.6 5.4-6.5 10.1-11.7 14-0.6 0.5-1.4 0.8-2.3 0.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m36.2 46.5c-0.8 0-1.6-0.3-2.3-0.8-5-3.8-8.9-8.4-11.5-13.8-2.6-5.3-3.9-11.4-3.9-17.9 0-1.1 0.5-2.2 1.4-2.9 0.7-0.6 1.6-0.9 2.4-0.9 0.3 0 0.6 0.1 1 0.2 0.8 0.1 2.1 0.3 3.6 0.3q4.1 0 7.3-2.1c0.6-0.4 1.3-0.6 2-0.6 0.8 0 1.5 0.2 2.1 0.6 2.1 1.4 4.6 2.1 7.3 2.1 1.4 0 2.7-0.2 3.5-0.3 0.5-0.1 0.8-0.2 1.1-0.2 0.8 0 1.7 0.3 2.4 0.9 0.9 0.7 1.4 1.8 1.4 2.9 0 6.4-1.3 12.4-3.8 17.7-2.6 5.4-6.5 10.1-11.7 14-0.6 0.5-1.4 0.8-2.3 0.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m36.2 45.1c-0.6 0-1.2-0.2-1.7-0.6-4.8-3.6-8.5-8-10.9-13.1-2.5-5.1-3.8-10.8-3.7-16.9 0-0.9 0.4-1.7 1-2.3 0.6-0.4 1.2-0.6 1.9-0.6q0.2 0 0.8 0.1c0.8 0.1 2.1 0.3 3.6 0.3q4.2 0 7.5-2.1 0.7-0.4 1.5-0.5 0.9 0 1.6 0.5c2.2 1.4 4.7 2.1 7.5 2.1 1.4 0 2.7-0.2 3.5-0.3 0.4-0.1 0.7-0.1 0.9-0.1 0.7 0 1.3 0.2 1.8 0.6 0.7 0.6 1.1 1.4 1.1 2.2 0 6.1-1.2 11.8-3.6 16.8-2.4 5.1-6.1 9.6-11 13.3-0.5 0.4-1.1 0.6-1.8 0.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m36.2 44.7q-0.8 0-1.5-0.5c-4.7-3.5-8.4-7.9-10.8-12.9-2.5-5.1-3.7-10.7-3.7-16.9 0-0.7 0.4-1.4 1-1.9 0.4-0.4 1-0.6 1.6-0.6q0.2 0 0.8 0.1c0.8 0.1 2.1 0.4 3.6 0.4 2.9 0 5.4-0.8 7.7-2.2q0.6-0.4 1.4-0.4 0.7 0 1.3 0.4c2.3 1.4 4.9 2.2 7.7 2.2 1.5 0 2.7-0.2 3.5-0.4q0.6-0.1 0.9-0.1c0.6 0 1.2 0.2 1.6 0.6 0.6 0.5 0.9 1.2 1 2 0 6-1.2 11.6-3.6 16.6-2.4 5-6.1 9.5-10.9 13.1q-0.7 0.5-1.6 0.6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEscudosBajo);
export default __webpack_public_path__ + "static/media/escudos_bajo.97bcf0da869e10fdccbf487793fb5afd.svg";
export { ForwardRef as ReactComponent };